const Youtube = ({ playlistID }) => (
  <section className="section-padding">
    <div className="container text-center">
      <h2 className="text-uppercase">
        Watch the{' '}
        <a
          href={`https://www.youtube.com/playlist?list=${playlistID}`}
          target="_blank"
          rel="noreferrer"
          className="text-dark"
        >
          Latest Challenges
        </a>
        !
      </h2>
      <div className="ratio ratio-16x9">
        <iframe
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/videoseries?list=${playlistID}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  </section>
);

export default Youtube;
